import { logAndylitics, log, logAPI } from "./andyliticsApi";
import * as tools from "../helpers/Tools";


const BASE_URL = typeof window !== 'undefined' ? window.serverData.data.mybswhealthbff : '';
const API_KEY = typeof window !== 'undefined' ? window.serverData.data.mybswhealthbfffunctionskey : '';
const SURVEY_URL = typeof window !== 'undefined' ? window.serverData.data.surveyUrl : '';

export const getThriveCard = (token) => {
    const fullUrl = window.serverData.data.enableThrive365Tile ? `${BASE_URL}v2/thriveCard` : `${BASE_URL}thriveCard`;

    const params = {
        headers: {
            "Authorization": `bearer ${token}`,
            "x-functions-key": API_KEY,
            "Cache-Control": "no-cache",
            "Pragma": "no-cache"
        },
        method: "GET"
    };

    var start = new Date();
    
    return fetch(fullUrl, params)
        .then(response => {
            logAPI("MBHWeb.Api.Thrive.Card.Get", start, fullUrl);
            return response.json();
        })
        .catch(err => {
            console.log("getThriveCard api Error", err);
            logAPI("MBHWeb.Api.Thrive.Card.Get.Failure", start, fullUrl, err);
            return Promise.reject(err);
        });
    
};


export const getThriveReport = (token) => {

    return getThriveReportV2(token, new Date().getFullYear());

    const fullUrl = tools.buildUrl(SURVEY_URL, 'wellness/v2/wellbeingscore/getuserthrivereport?year=' + encodeURIComponent(reportYear));
    //const fullUrl = `${SURVEY_URL}wellness/v2/wellbeingscore/getuserthrivereport?year=2020`;

    const params = {
        headers: {
            "Authorization": `bearer ${token}`,
            "x-functions-key": API_KEY,
            "Cache-Control": "no-cache",
            "Pragma": "no-cache"
        },
        method: "GET"
    };

    var start = new Date();

    /*
    // TODO: for now, return a mock object. Replace with the fetch below when the api is fixed.
    const mock = {
        overallScore: 75,
        overallScoreColor: "#FFC844",
        overallScoreInterpretation: "Looking good! Keep up the good work, Jennifer.",
        results: [
            {
                name: "Professional",
                score: 75,
                scoreColor: "#FFC844",
                goals: ["Eat better to lose weight"],
                goalLink: "www.google.com"
            },
            {
                name: "Physical",
                score: 75,
                scoreColor: "#FFC844",
                goals: ["Eat better to lose weight"],
                goalLink: "www.google.com"
            },
            {
                name: "Social",
                score: 100,
                scoreColor: "#00C4B3",
                goals: ["Eat better to lose weight"],
                goalLink: "www.google.com"
            },
            {
                name: "Emotional",
                score: 98,
                scoreColor: "#00C4B3",
                goals: [],
                goalLink: ""
            },
            {
                name: "Financial",
                score: 75,
                scoreColor: "#FFC844",
                goals: [],
                goalLink: ""
            }],
        discussionPoints: [
            "Anxiety screening",
            "Concerning back pain"
        ],
        pledge: "In 2019, I pledge to work hard towards my goals, stay consistent, and be my best!"
    };
    
    return Promise.resolve(mock);
    */
    return fetch(fullUrl, params)
        .then(response => {
            logAPI("MBHWeb.Api.Thrive.Report.Get", start, fullUrl);
            return response.json();
        })
        .catch(err => {
            console.log("getThriveCard api Error", err);
            logAPI("MBHWeb.Api.Thrive.Report.Get.Failure", start, fullUrl, err);
            return Promise.reject(err);
        });
};


export const getThriveReportV2 = (token, reportYear) => {
    const fullUrl = tools.buildUrl(SURVEY_URL, 'wellness/v2/wellbeingscore/getuserthrivereport?year=' + encodeURIComponent(reportYear));
    //const fullUrl = `${SURVEY_URL}wellness/v2/wellbeingscore/getuserthrivereport?year=${reportYear}`;
    
    const params = {
        headers: {
            "Authorization": `bearer ${token}`,
            "x-functions-key": API_KEY,
            "Cache-Control": "no-cache",
            "Pragma": "no-cache"
        },
        method: "GET"
    };

    var start = new Date();

    /*
    // TODO: for now, return a mock object. Replace with the fetch below when the api is fixed.
    const mock = {
        overallScore: 75,
        overallScoreColor: "#FFC844",
        overallScoreInterpretation: "Looking good! Keep up the good work, Jennifer.",
        results: [
            {
                name: "Professional",
                score: 75,
                scoreColor: "#FFC844",
                goals: ["Eat better to lose weight"],
                goalLink: "www.google.com"
            },
            {
                name: "Physical",
                score: 75,
                scoreColor: "#FFC844",
                goals: ["Eat better to lose weight"],
                goalLink: "www.google.com"
            },
            {
                name: "Social",
                score: 100,
                scoreColor: "#00C4B3",
                goals: ["Eat better to lose weight"],
                goalLink: "www.google.com"
            },
            {
                name: "Emotional",
                score: 98,
                scoreColor: "#00C4B3",
                goals: [],
                goalLink: ""
            },
            {
                name: "Financial",
                score: 75,
                scoreColor: "#FFC844",
                goals: [],
                goalLink: ""
            }],
        discussionPoints: [
            "Anxiety screening",
            "Concerning back pain"
        ],
        pledge: "In 2019, I pledge to work hard towards my goals, stay consistent, and be my best!"
    };
    
    return Promise.resolve(mock);
    */
    return fetch(fullUrl, params)
        .then(response => {
            logAPI("MBHWeb.Api.Thrive.Report.Get", start, fullUrl);
            return response.json();
        })
        .catch(err => {
            console.log("getThriveReportV2 api Error", err);
            logAPI("MBHWeb.Api.Thrive.Report.Get.Failure", start, fullUrl, err);
            return Promise.reject(err);
        });
};

export const getWellBeingReport = (token, reportYear) => {
    const fullUrl = tools.buildUrl(SURVEY_URL, 'wellness/wellbeingscore/GetWellnessReport?year=' + encodeURIComponent(reportYear));
    const params = {
        headers: {
            "Authorization": `bearer ${token}`,
            "x-functions-key": API_KEY,
            "Cache-Control": "no-cache",
            "Pragma": "no-cache"
        },
        method: "GET"
    };

    var start = new Date();

    return fetch(fullUrl, params)
        .then(response => {
            logAPI("MBHWeb.Api.Thrive.WellBeingReport.Get", start, fullUrl);
            return response.json();
        })
        .catch(err => {
            console.log("getWellBeingReport api Error", err);
            logAPI("MBHWeb.Api.Thrive.WellBeingReport.Get.Failure", start, fullUrl, err);
            return Promise.reject(err);
        });
};

export const getReportPdf = (token, reportYear) => {
    const fullUrl = tools.buildUrl(SURVEY_URL, 'Wellness/WellBeingScore/GetWellnessReportPDF?year=' + encodeURIComponent(reportYear));
    const params = {
        headers: {
            "Authorization": `bearer ${token}`,
            "x-functions-key": API_KEY,
            "Cache-Control": "no-cache",
            "Pragma": "no-cache"
        },
        method: "GET"
    };

    var start = new Date();

    return fetch(fullUrl, params)
        .then(response => {
            const filename = "WellbeingReport.pdf";
            response.blob().then(blob => {
                let url = window.URL.createObjectURL(blob);
                let a = document.createElement('a');
                a.href = url;
                a.download = filename;
                a.click();
            });
            logAPI("MBHWeb.Api.Thrive.ReportPdf.Get", start, fullUrl);
            return response.json();
        })
        .catch(err => {
            logAPI("MBHWeb.Api.Thrive.ReportPdf.Get.Failure", start, fullUrl, err);
            return Promise.reject(err);
        });
}

